module.exports = __webpack_public_path__ + "static/img/7.5f6df31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/sp/7.png
// module id = OrM5
// module chunks = 0